import { render, staticRenderFns } from "./recharge-record.vue?vue&type=template&id=84ab54c2&scoped=true&"
import script from "./recharge-record.vue?vue&type=script&lang=js&"
export * from "./recharge-record.vue?vue&type=script&lang=js&"
import style0 from "./recharge-record.vue?vue&type=style&index=0&id=84ab54c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ab54c2",
  null
  
)

export default component.exports